import { Field, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CONSTANTS } from '../../constants';
import { ResetUserPasswordSchema } from '../../yupValidationSchemas/resetUserEmail.validationSchema';
import AuthWelcomeBlock from '../AuthWelcomeBlock';
import ButtonComponent from '../UI/Button/Button.component';
import './reset-password.scss';

const initialState = {
  password: '',
  passwordConfirm: '',
};

const ResetPassword = () => {
  const params = useParams();
  const [userToken, setUserToken] = useState<string | null>('');
  const [userId, setUserId] = useState<string | null>('');

  const queryParamsToken = new URLSearchParams(params.search).get('token');
  const queryParamsId = new URLSearchParams(params.search).get('id');

  const { error } = useSelector((state: any) => state.user);

  useEffect(() => {
    setUserToken(queryParamsToken);
    setUserId(queryParamsId);
  }, [queryParamsId, queryParamsToken]);

  const handleResetPassword = (data: any) =>
    new Promise((resolve, reject) => {
      reject(Error);
    });

  return (
    <div className="ResetPassword__Grid">
      <div className="ResetPassword__Wrapper">
        <AuthWelcomeBlock header={CONSTANTS.USER.RESET_PASSWORD_TEXT} />
        <Formik
          initialValues={initialState}
          validationSchema={ResetUserPasswordSchema}
          onSubmit={(values) => {
            const updatedValues = {
              userId,
              token: userToken,
              password: values.password,
            };
            handleResetPassword(updatedValues);
          }}
        >
          {({ errors, touched, isValid }) => (
            <Form className="ResetPassword__Form needs-validation">
              <div className="ResetPassword__UserInput">
                <Field
                  className={`ResetPassword__FormInput form-control ${
                    errors.password && touched.password ? 'is-invalid' : ''
                  }`}
                  id="password"
                  name="password"
                  placeholder="Password"
                  type="password"
                />
                {errors.password && touched.password ? (
                  <p className="custom-invalid-feedback">{errors.password}</p>
                ) : null}
              </div>
              <div className="ResetPassword__UserInput">
                <Field
                  className={`ResetPassword__FormInput form-control ${
                    errors.passwordConfirm && touched.passwordConfirm
                      ? 'is-invalid'
                      : ''
                  }`}
                  id="passwordConfirm"
                  name="passwordConfirm"
                  placeholder="Confirm Password"
                  type="password"
                />
                {errors.passwordConfirm && touched.passwordConfirm ? (
                  <p className="custom-invalid-feedback">
                    {errors.passwordConfirm}
                  </p>
                ) : null}
              </div>
              <ButtonComponent
                className="ResetPassword__Button"
                variant="primary"
                disabled={
                  !isValid ||
                  (Object.keys(touched).length === 0 &&
                    touched.constructor === Object)
                }
                type="submit"
              >
                Submit
              </ButtonComponent>
            </Form>
          )}
        </Formik>
        {error?.message?.errorMessage && (
          <div className="form-group">
            <div className="alert alert-danger" role="alert">
              {error?.message?.errorMessage}
            </div>
          </div>
        )}
        <hr className="ResetPassword__Ruler" />
      </div>
    </div>
  );
};

export default ResetPassword;
